import { LinkProps as NextLinkProps } from 'next/link';
import { AnchorHTMLAttributes, ButtonHTMLAttributes, PropsWithChildren } from 'react';

import styles from './link.module.css';
import { useBottomNavigation } from '../../../../bottom-navigation.context';

export type LinkProps = PropsWithChildren<
  (NextLinkProps & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target'>) | ButtonHTMLAttributes<HTMLButtonElement>
>;

export const Link = ({ children, ...props }: LinkProps) => {
  const { linkFactory } = useBottomNavigation();
  if ('href' in props) {
    return linkFactory({ ...props, className: styles.link, children });
  }

  return (
    <button className={styles.link} {...props}>
      {children}
    </button>
  );
};
